import { render, staticRenderFns } from "./multiUserComponent.vue?vue&type=template&id=8b337f3a&scoped=true&"
import script from "./multiUserComponent.vue?vue&type=script&lang=js&"
export * from "./multiUserComponent.vue?vue&type=script&lang=js&"
import style0 from "./multiUserComponent.vue?vue&type=style&index=0&id=8b337f3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b337f3a",
  null
  
)

export default component.exports